import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "utils/api";
import { useAppSelector } from "../redux/hooks";

export const FollowPixel = () => {
  const location = useLocation();
  const user = useAppSelector((state) => state.user);

  const sendFollow = (path: string) => {
    const payload = {
      url: path,
    };
    void api.post("/merchandise/follow/log", payload);
  };

  useEffect(() => {
    if (!user.user_id || !user.organization_id) return;

    sendFollow(location.pathname);
  }, [location, user]);

  return null;
};
